import React, { useEffect, useState } from "react";
import { Stack, Box, Typography, Tabs, Tab } from "@mui/material";
import Chart from "react-apexcharts";
import {
  GET_CUSTOMER_BILLING_TYPE_GRAPH,
  GET_PROJECT_BILLING_TYPE_GRAPH,
  GET_BROKER_BILLING_TYPE_GRAPH,
  GET_PROJECT_LAG_GRAPH,
  GET_BROKER_LAG_GRAPH,
} from "../../constants/ApiRoute";
import { authHeader } from "../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import API from "../comman/API";
import { PolarArea } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import NoRecordFound from "../comman/NoRecordFound";

// Register the required components
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

export default function BillingTypeAvgLagGraph(props) {
  const { headerTab, customerTab, brokerTab, selectedBroker } = props;

  const [value, setValue] = useState(0);
  const [ploarGraphData, setPloarGraphData] = useState([]);
  const [ploarGraphOptionData, setPloarGraphOptionData] = useState([]);
  const [ploarGraphBrokerData, setPloarGraphBrokerData] = useState([]);
  const [ploarGraphOptionBrokerData, setPloarGraphOptionBrokerData] = useState(
    []
  );
  const [seriessBT, setBTSeries] = useState([]);
  const [labelssBT, setBTLabels] = useState([]);

  useEffect(() => {
    getBrokerLag();
  }, [brokerTab.brokerId]);

  useEffect(() => {
    if (brokerTab.customerId && brokerTab.projectId == "") {
      getBillingTypeFunc(brokerTab.customerId, "customer");
    }
    if (brokerTab.projectId) {
      getBillingTypeFunc(brokerTab.projectId, "project");
    }
    if (brokerTab.brokerId) {
      getBillingTypeFunc(brokerTab.brokerId, "broker");
    }
  }, [brokerTab]);

  useEffect(() => {
    getBrokerLag();
  }, []);

  useEffect(() => {
    getProjectLag();
  }, [brokerTab.projectId]);

  const getBillingTypeFunc = async (idValue, typeFunc) => {
    let data = {};
    let urlPath = "";

    if (typeFunc == "customer") {
      data.customerId = idValue ? idValue : "";
      urlPath = GET_CUSTOMER_BILLING_TYPE_GRAPH;
    } else if (typeFunc == "project") {
      data.projectId = idValue ? idValue : "";
      urlPath = GET_PROJECT_BILLING_TYPE_GRAPH;
    } else if (typeFunc == "broker") {
      data.userId = idValue ? idValue : "";
      urlPath = GET_BROKER_BILLING_TYPE_GRAPH;
    }

    const config = {
      method: "GET",
      url: urlPath,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const seriesData = data
          .filter((item) => item.billingType != null)
          .map((item) => item.billingTypeCount);

        const labelsData = data
          .filter((item) => item.billingType != null)
          .map((item) => item.billingType);

        setBTSeries(seriesData);
        setBTLabels(labelsData);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);

        if (v.message == "No record found.") {
          setBTSeries([]);
          setBTLabels([]);
        }

        console.log("datadata", data);
      }
    } finally {
    }
  };

  const getProjectLag = async () => {
    let data = {
      projectId: brokerTab.projectId,
    };

    const config = {
      method: "GET",
      url: GET_PROJECT_LAG_GRAPH,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const dataVal = {
          labels: data.map((entry) => entry.UserName),
          datasets: [
            {
              // label: "Average Lag Time",
              label: "",
              data: data.map((entry) => entry.AvgLaqTime),
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(75, 192, 192, 0.2)",
              ],
              borderColor: ["rgb(255, 99, 132)", "rgb(75, 192, 192)"],
              borderWidth: 1,
            },
          ],
        };

        const options = {
          responsive: true,
          scales: {
            r: {
              angleLines: {
                display: false,
              },
              suggestedMin: 0,
              suggestedMax: 40, // Adjust max based on your data range
            },
          },
          plugins: {
            legend: {
              display: false, // Hide the legend if that's the "top label" you're referring to
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const value = context.raw; // Access the raw data value
                  return `${value.toFixed(2)}`; // Format with 2 decimal places
                },
              },
            },
          },
        };
        

        setPloarGraphOptionData(options);
        setPloarGraphData(dataVal);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        setPloarGraphOptionData([]);
        setPloarGraphData([]);
      }
    } finally {
    }
  };

  const getBrokerLag = async () => {
    // Test Data Start

    // const dataValTest = {
    //   labels: ["broker 1", "broker 2"],
    //   datasets: [
    //     {
    //       label: "Average Lag Time",
    //       data: [10,20],
    //       backgroundColor: [
    //         "rgba(255, 99, 132, 0.2)",
    //         "rgba(75, 192, 192, 0.2)"
    //       ],
    //       borderColor: [
    //         "rgb(255, 99, 132)",
    //         "rgb(75, 192, 192)"
    //       ],
    //       borderWidth: 1,
    //     },
    //   ],
    // };

    // const optionsTest = {
    //   responsive: true,
    //   scales: {
    //     r: {
    //       angleLines: {
    //         display: false,
    //       },
    //       suggestedMin: 0,
    //       suggestedMax: 40,
    //     },
    //   },
    // };
    // setPloarGraphOptionBrokerData(optionsTest)
    // setPloarGraphBrokerData(dataValTest)

    // Test Data End

    let data = {
      userId: brokerTab.brokerId,
    };

    const config = {
      method: "GET",
      url: GET_BROKER_LAG_GRAPH,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const dataVal = {
          labels: data.map((entry) => entry.Name),
          datasets: [
            {
              // label: "Average Lag Time",
              label: "",
              data: data.map((entry) => entry.AvgLaqTime),
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(75, 192, 192, 0.2)",
              ],
              borderColor: ["rgb(255, 99, 132)", "rgb(75, 192, 192)"],
              borderWidth: 1,
            },
          ],
        };

        const options = {
          responsive: true,
          scales: {
            r: {
              angleLines: {
                display: false,
              },
              suggestedMin: 0,
              suggestedMax: data.length, // Adjust max based on your data range
            },
          },
          plugins: {
            legend: {
              display: false, // Hide the legend if that's the "top label" you're referring to
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const value = context.raw; // Access the raw data value
                  return `${value.toFixed(2)}`; // Format with 2 decimal places
                },
              },
            },
          },
        };

        setPloarGraphOptionBrokerData(options);
        setPloarGraphBrokerData(dataVal);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        setPloarGraphOptionBrokerData([]);
        setPloarGraphBrokerData([]);
      }
    } finally {
    }
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {Object.values(brokerTab) && (
        <Box className="dashboard-countbox">
          <Box
            className="dashboard-tabs"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              {brokerTab.brokerId ? (
                <Tab label="Billing Type" {...a11yProps(0)} />
              ) : (
                ""
              )}

              {brokerTab.brokerId ? (
                <Tab label="Average Lag" {...a11yProps(1)} />
              ) : (
                ""
              )}
            </Tabs>
          </Box>

          {brokerTab.brokerId ? (
            <CustomTabPanel
              className="dashboard-tab-content"
              value={value}
              index={0}
            >
              {labelssBT && labelssBT.length > 0 ? (
                <div
                  className="donut bill-avg-graph"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    margin: "0 auto",
                    height: "350px",
                  }}
                >
                  <Chart
                    options={{
                      labels: labelssBT,
                      plotOptions: {
                        pie: {
                          donut: {
                            size: "50%",
                          },
                        },
                        legend: {
                          show: false, // This hides the legend
                        },
                      },
                    }}
                    series={seriessBT}
                    type="donut"
                    width="100%"
                  />
                </div>
              ) : (
                // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
                //   No Record Found
                // </Typography>
                <NoRecordFound />
              )}
            </CustomTabPanel>
          ) : (
            ""
          )}

          {brokerTab.brokerId ? (
            <CustomTabPanel
              className="dashboard-tab-content"
              value={value}
              index={1}
            >
              {brokerTab.brokerId && !brokerTab.projectId ? (
                ploarGraphOptionBrokerData &&
                ploarGraphOptionBrokerData.responsive ? (
                  <div className="chart-container">
                    <PolarArea
                      data={ploarGraphBrokerData}
                      options={ploarGraphOptionBrokerData}
                    />
                  </div>
                ) : (
                  // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
                  //   No Record Found
                  // </Typography>
                  <NoRecordFound />
                )
              ) : ploarGraphOptionData && ploarGraphOptionData.responsive ? (
                <div className="chart-container">
                  <PolarArea
                    data={ploarGraphData}
                    options={ploarGraphOptionData}
                  />
                </div>
              ) : (
                // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
                //   No Record Found
                // </Typography>
                <NoRecordFound />
              )}
            </CustomTabPanel>
          ) : (
            ""
          )}
        </Box>
      )}
    </>
  );
}
